module.exports = __webpack_public_path__ + "img/wallet_debt.44d265d5.svg";